import React from 'react';
import CreatableSelect from 'react-select/creatable';

import CustomDropdown from '@/components/CustomDropdown';
import CommonImage from '@/components/CommonImage';

const TaskConfigurationModal = () => {
	return (
		<div className="popup-wrapper create-task-configuration-modal">
			<div className="common-popup create-task-configuration-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Create task</h3>
					</div>
					<div className="close-btn">
						<CommonImage alt="close" src="/icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label body-scroll">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Project Name</label>
								<input type="text" />
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Stage</label>
								<CustomDropdown
									title="Project type*"
									onItemClick={() => {}}
									selectedItem={''}
									items={[]}
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group two-step-form-group">
								<label htmlFor="collection">Stage</label>
								<div className="d-flex align-items-center">
									<div className="task-side-step">
										<CustomDropdown
											title="After"
											onItemClick={() => {}}
											selectedItem={''}
											items={[]}
										/>
									</div>
									<div className="w-100">
										<CustomDropdown
											title="Task Step"
											onItemClick={() => {}}
											selectedItem={''}
											items={[]}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor>Completion condition</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor>Dependency</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor>Who can complete?</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor>Not required, if it’s</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Stage</label>
								<CustomDropdown
									title="Project type*"
									onItemClick={() => {}}
									selectedItem={''}
									items={[]}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TaskConfigurationModal;
